export default __webpack_public_path__ + "static/media/no-notes.900de42d.png";